<template>
  <v-dialog
    :value="value"
    transition="dialog-top-transition"
    fullscreen
    scrollable
    persistent
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title class="text-h5 primary" style="color: white">
        Лента звонков
        <v-spacer />
        <v-btn icon @click="close" color="white">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text ref="scrollable_area">

        <v-card
          v-for="(item, key) in items"
          elevation="5"
          :key="'calls_feed_' + key"
          class="my-6 pa-3 widget"
          v-intersect.once="onCardIntersect"
        >
          <v-row>
            <!-- Стенограмма -->
            <v-col cols="12" md="5" class="d-flex">
              <Transcribe :messages="item.clearTranscribe" table-mode />
            </v-col>

            <!-- ИИ анализ -->
            <v-col cols="12" md="3">
              <v-card class="pa-2 fill-height">
                <p v-for="(ai, key) in item.clearAnalysis" :key="'ai_' + ai.code + key">
                  <b>{{ ai.label }}</b> <br>
                  {{ ai.value }}
                </p>

                <p v-if="item.clearAnalysis == null || item.clearAnalysis.length === 0">Нет анализа</p>
              </v-card>
            </v-col>

            <!-- Инфа по вызову -->
            <v-col cols="12" md="3">
              <v-card class="pa-2 fill-height">
                <p><b>UID:</b> <br>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      rounded
                      color="info"
                      :href="callUrl(item.uid)"
                      target="_blank"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ item.uid }} <v-icon>mdi-dock-window</v-icon>
                    </v-btn>
                  </template>
                  <span>Переход в информацию по звонку (откроется в новой вкладке)</span>
                </v-tooltip>
                </p>
                <p><b>Время звонка</b> <br>
                  {{ item.t1 }}
                </p>
                <p><b>Статус</b> <br>
                  {{ item.status_title }}
                </p>
                <p><b>Номер звонящего</b> <br>
                  {{ item.client_phone }}
                </p>
                <p><b>Агент</b> <br>
                  [{{ item.agent_sip }}] {{ item.user.full_name }}
                </p>
                <p><b>Очередь</b> <br>
                  {{ item.queue }}
                </p>
                <p><b>Ожидание, сек.</b> <br>
                  {{ item.wait }}
                </p>
                <p><b>Продолжительность, сек.</b> <br>
                  {{ item.duration }}
                </p>
                <p><b>Удержание (Hold), сек</b> <br>
                  {{ item.hold_dur }}
                </p>
              </v-card>
            </v-col>

            <!-- Лайк / Дизлайк -->
            <v-col
              cols="12"
              md="1"
              class="d-flex justify-space-around align-center"
              :class="{'flex-column': ['lg', 'xl', 'md'].includes(sсreenWidthName)}"
            >
              <v-btn
                elevation="5"
                fab
                icon
                x-large
                style="scale: 1.1;"
                :loading="item.loadingLike"
                :disabled="item.loadingLike"
                @click="setLike(item)"
              >
                <v-icon :color="item.has_like ? 'red' : ''">{{ item.has_like ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
              </v-btn>
              <v-btn
                elevation="5"
                fab
                icon
                x-large
                style="scale: 1.1;"
                :style="{order: ['lg', 'xl', 'md'].includes(sсreenWidthName) ? 'revert' : '-1'}"
                :loading="item.loadingLike"
                :disabled="item.loadingLike"
                @click="setDislike(item)"
              >
                <v-icon :color="item.has_dislike ? 'black' : ''">{{ item.has_dislike ? 'mdi-thumb-down' : 'mdi-thumb-down-outline' }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-skeleton-loader v-if="loading" type="card" />

        <div ref="observer" id="observer" style="height: 1px;"></div>

        <v-alert
          v-if="feedEnds"
          border="bottom"
          color="blue-grey"
          dark
        >Это конец ленты </v-alert>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="close">Закрыть</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>


<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import Transcribe from "~/components/partials/Call/Transcribe"
import moment from 'moment'

export default {
  name: 'CallsFeed',
  components: {
    Transcribe,
  },
  props: {
    value: Boolean,
    filters: {
      type: Object,
      default() {return {}},
    },
  },
  data() {
    return {
      items: [],
      wasRender: false,
      loading: false,
      feedEnds: false,
      page: 1,
      limit: 3,
      totalPages: null,
      observer: null,
      viewedCount: 0,
    }
  },

  computed: {
    sсreenWidthName() {
      return this.$vuetify.breakpoint.name
    },
  },

  watch: {
    value(val) {
      if (val) this.clearAll()
      
      if (this.wasRender) return
      if (val) this.wasRender = true
      this.initOnFirstOpen()
    },
  },

  methods: {
    ...mapActions({
      loadGraph: 'graphql/loadGraph',
      setSuccess: 'shared/setSuccess',
      setError: 'shared/setError',
    }),

    close() {
      this.$emit('input', false)
    },

    async loadMore(entries) {
      if (entries && entries[0].isIntersecting === false) return
      if (this.loading) return

      this.loading = true
      await this.addCall()
      this.loading = false
    },

    async initOnFirstOpen() {
      await this.$nextTick()

      // const options = {
      //   root: this.$refs['scrollable_area'],
      //   rootMargin: '0px 0px 200px 0px' // Марджин выстрела обсёрвера
      // }

      // this.observer = new IntersectionObserver(this.loadMore, options)
      // this.observer.observe(this.$refs.observer)

      await this.addCall()
    },

    async loadCall() {
      this.loading = true
      const period = {
        start: moment(this.filters.period.start).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(this.filters.period.end).format('YYYY-MM-DD HH:mm:ss')
      }

      if (moment().isSame(moment(this.filters.period.end), 'day')) {
        period.end = moment().subtract(2, 'minute').format('YYYY-MM-DD HH:mm:ss')
      }

      const users = this.filters.users.length > 0 ? `users: [${this.filters.users.join(', ')}], ` : ''
      const types = this.filters.types.length > 0 ? `types: ["${this.filters.types.join('", "')}"], ` : ''
      const phoneNumber = this.filters.phone_number ? `phone_number: "${this.filters.phone_number}",` : ''
      const dictionaries = this.filters.dictionaries?.length > 0 ? `exclude_dictionaries: [${this.filters.dictionaries.join(', ')}],` : ''
      const excludeВictionaries = this.filters.dictionaries_excluded?.length > 0 ? `exclude_dictionaries: [${this.filters.dictionaries_excluded.join(', ')}],` : ''
      const duration = this.filters.duration ? `duration: [${this.filters.duration.from}, ${this.filters.duration.to}],` : ''

      const only_recognized = this.filters.additional.includes('only_recognized') ? 'only_recognized: true,' : ''
      const only_kln = this.filters.additional.includes('only_kln') ? 'only_kln: true,' : ''
      const only_dropped = this.filters.additional.includes('only_dropped') ? 'only_dropped: true,' : ''
      const only_сallback = this.filters.additional.includes('only_сallback') ? 'only_сallback: true,' : ''

      const query = `calls(
          period: ["${period.start}", "${period.end}"],
          projects: [${this.filters.projects.join(', ')}],
          statuses: ["${this.filters.statuses.join('", "')}"],
          ${duration}
          ${types}
          ${users}
          ${phoneNumber}
          ${excludeВictionaries}
          ${dictionaries}

          ${only_recognized}
          ${only_kln}
          ${only_dropped}
          ${only_сallback}
          page: ${this.page},
          limit: ${this.limit},
          order_by: "desc"
        ) {
          data {
            uid
            analysis
            transcribe
            has_like
            has_dislike
            status_title
            client_phone
            queue
            wait
            agent_sip
            user {full_name}
            t1
            duration
            hold_dur

            has_like
            has_dislike
          }
          total
          per_page
          current_page
          last_page
        }`

      const res = await axios.post('/api/graphql/v1', {
        query: `{${query}}`
      })
      .catch(error => {
        console.error(error)
        this.setError({message: error})
        throw error
      })

      this.loading = false

      return res.data.data.calls
    },

    async addCall() {
      if (this.totalPages !== null && this.page > this.totalPages) {
        this.feedEnds = true
        return
      }

      if (this.loading) return

      const call = await this.loadCall()

      this.totalPages = call.last_page
      if (call.total === 0) {
        this.feedEnds = true
        return
      }
      if (this.page <= this.totalPages) this.page++

      const items = this.prepareItems(call.data)

      this.items.push(...items)
      this.sortItems()
    },

    async setLike(item) {
      item.loadingLike = true
      const uid = item.uid

      axios.post(`/api/calls/${uid}/set-like`)
        .then(response => {
          const res = response.data
          item.has_like = res.is_like
          item.has_dislike = res.is_dislike
          this.setSuccess({message: res.message})
        })
        .catch(error => {
          this.setError({message: error})
          throw error
        })
        .finally(() => {
          item.loadingLike = false
        })
    },
    async setDislike(item) {
      item.loadingLike = true
      const uid = item.uid

      axios.post(`/api/calls/${uid}/set-dislike`)
        .then(response => {
          const res = response.data
          item.has_like = res.is_like
          item.has_dislike = res.is_dislike
          this.setSuccess({message: res.message})
        })
        .catch(error => {
          this.setError({message: error})
          throw error
        })
        .finally(() => {
          item.loadingLike = false
        })
    },

    clearAll() {
      this.items = []
      this.wasRender = false
      this.loading = false
      this.feedEnds = false
      this.page = 1
      this.totalPages = null
      this.viewedCount = 0

      if (this.observer) {
        this.observer.disconnect()
      }
    },

    callUrl(uid) {
      return `${process.env.VUE_APP_API_DOMAIN}${this.$router.resolve({
        name: 'SpeechAnalysisCall',
        params: {uid}
      }).href}`
    },

    onCardIntersect(entries, observer, isIntersecting) {
      if (isIntersecting === false) return
      this.viewedCount++
      this.addCall()
    },

    sortItems() {
      this.items.sort((a,b) => {
        const aTime = moment(a.t1)
        const bTime = moment(b.t1)
        return aTime.isBefore(bTime)
      })
    },

    prepareItems(items) {
      return items.map(c => {
        c.clearAnalysis = JSON.parse(c.analysis)
        c.clearTranscribe = JSON.parse(c.transcribe)
        c.loadingLike = false
        return c
      })
    },
  },

  mounted() {},

}
</script>


<style scoped lang="scss">
.widget {
  border: 1px solid hsla(0,0%,42.7%,.30980392156862746);
  box-shadow: 0 0 7px #6d6d6d !important;
  border-radius: 10px;

  .theme--dark & {
    background: linear-gradient(60deg, rgb(36, 36, 36), rgb(61, 61, 61));
  }
  .theme--light & {
    background: linear-gradient(120deg, rgb(242, 242, 242), rgb(212, 212, 212));
  }
}
</style>